import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { createAction } from '@mews/framework';
import SubjectFieldComponent from '../components/SubjectFieldComponent';
import { THREAD_SUBJECT_DRAFT_UPDATED } from '../actionTypes';
import { currentThread } from '../selectors/threads';
import { isEditingSubject, threadSubjectDraft } from '../selectors';

export default connect(
    createStructuredSelector({
        isEditMode: isEditingSubject,
        subjectDraft: threadSubjectDraft,
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        thread: currentThread,
    }),

    (dispatch) => ({
        subjectDraftUpdated: (text: $TSFixMe) => dispatch(createAction(THREAD_SUBJECT_DRAFT_UPDATED, text)),
    })
)(SubjectFieldComponent);
